module.exports = "/_next/static/images/9d3b4dddf0f370c30e5412b874b48ec1-pregnant-woman@desktop@1x.jpg";